<template>
  <div class="advertisement-create-page">
    <a-card :bordered="false">
      <template slot="title">
        <page-back-title :title="pageTitle" />
      </template>
      <a-spin :spinning="detailLoading">

      <div class="steps-wrap">
        <a-steps :current="current" @change="onStepChange">
          <a-step v-for="item in steps" :key="item" :title="item" />
        </a-steps>
      </div>

      <!-- 步骤1：选择广告类型 -->
      <div v-show="current === 0" class="step-panel">
        <a-form-model
          ref="basicForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="标题" prop="title">
            <a-input v-model="form.title" placeholder="请输入" allow-clear />
          </a-form-model-item>
          <a-form-model-item label="起止日期" prop="dateRange">
            <a-range-picker
              v-model="form.dateRange"
              style="width: 100%"
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </a-form-model-item>
          <a-form-model-item label="广告类型" prop="adTypes">
            <a-select
              v-model="form.adTypes"
              mode="multiple"
              placeholder="请选择"
              allow-clear
              style="width: 100%"
            >
              <a-select-option
                v-for="item in adTypeOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="频率控制" prop="frequency">
            <a-select
              v-model="form.frequency"
              placeholder="请选择"
              style="width: 240px"
            >
              <a-select-option
                v-for="item in frequencyOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="工行分组" prop="deptId">
            <a-tree-select
              v-model="form.deptId"
              allow-clear
              style="width: 100%"
              placeholder="请选择，不选则不做受众筛选"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="groupTreeData"
              :load-data="onLoadDeptData"
              @change="onDeptChange"
            />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="offsetWrapperCol">
            <a-button type="primary" @click="onStep1Next">下一步</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>

      <!-- 步骤2：配置广告内容 -->
      <div v-show="current === 1" class="step-panel step-panel-content">
        <a-tabs v-model="activeContentTab" :animated="false">
          <a-tab-pane
            v-for="item in contentTabs"
            :key="String(item.value)"
            :tab="item.tabLabel"
          >
            <advertisement-content-panel
              v-if="contentMap[item.value]"
              :ad-type="item.value"
              :value="contentMap[item.value]"
              @input="val => onContentChange(item.value, val)"
            />
          </a-tab-pane>
        </a-tabs>
        <div class="footer-actions">
          <a-button @click="onStep2Back">上一步</a-button>
          <a-button type="primary" @click="onStep2Next">下一步</a-button>
        </div>
      </div>

      <!-- 步骤3：确认信息并发布 -->
      <div v-show="current === 2" class="step-panel step-panel-confirm">
        <advertisement-confirm-panel
          :tabs="contentTabs"
          :active-tab.sync="activeConfirmTab"
          :content-map="contentMap"
          :page-map="pageMap"
          @pages-change="onPagesChange"
        />
        <div class="footer-actions">
          <a-button @click="onStep3Back">上一步</a-button>
          <a-button type="primary" :loading="publishing" @click="onPublish">{{ publishText }}</a-button>
        </div>
      </div>
      </a-spin>
    </a-card>
  </div>
</template>

<script>
import PageBackTitle from '@/views/service_new/coupon/components/PageBackTitle.vue'
import AdvertisementContentPanel, {
  createEmptyContent
} from './components/AdvertisementContentPanel.vue'
import AdvertisementConfirmPanel from './components/AdvertisementConfirmPanel.vue'

const AD_TYPE_TAB_LABEL = {
  1: '开屏广告',
  2: '插屏广告',
  3: 'banner横幅(小卡)',
  4: 'banner横幅(大卡)'
}

/** UI jumpType -> 接口 jumpType：1商品 2活动 3链接 4小程序路径 */
const JUMP_TYPE_MAP = {
  product: 1,
  activity: 2,
  link: 3,
  miniProgram: 4
}

const JUMP_TYPE_REVERSE = {
  1: 'product',
  2: 'activity',
  3: 'link',
  4: 'miniProgram'
}

export default {
  name: 'AdvertisementCreate',
  components: {
    PageBackTitle,
    AdvertisementContentPanel,
    AdvertisementConfirmPanel
  },
  data() {
    return {
      current: 0,
      steps: ['广告基本信息', '配置广告内容', '确认信息并发布'],
      activeContentTab: '',
      activeConfirmTab: '',
      contentMap: {},
      pageMap: {},
      publishing: false,
      detailLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 12 },
      offsetWrapperCol: { span: 12, offset: 4 },
      adTypeOptions: [
        { label: '开屏', value: 1 },
        { label: '插屏', value: 2 },
        { label: '横幅小卡', value: 3 },
        { label: '横幅大卡', value: 4 }
      ],
      frequencyOptions: [
        { label: '每次启动弹', value: 0 },
        { label: '每天一次', value: 1 },
        { label: '每两天一次', value: 2 },
        { label: '每三天一次', value: 3 }
      ],
      groupTreeData: [],
      form: {
        adNo: '',
        title: '',
        dateRange: [],
        adTypes: [],
        frequency: 0,
        enterpriseId: undefined,
        deptId: undefined
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        dateRange: [{ required: true, message: '请选择起止日期', trigger: 'change' }],
        adTypes: [{ required: true, type: 'array', min: 1, message: '请选择广告类型', trigger: 'change' }],
        frequency: [{ required: true, message: '请选择频率控制', trigger: 'change' }]
      }
    }
  },
  computed: {
    isEdit() {
      return !!(this.form.adNo || (this.$route.query && this.$route.query.adNo))
    },
    pageTitle() {
      return this.isEdit ? '编辑广告' : '新建广告'
    },
    publishText() {
      return this.isEdit ? '确认并保存' : '确认并发布'
    },
    contentTabs() {
      return (this.form.adTypes || []).map(value => ({
        value,
        tabLabel: AD_TYPE_TAB_LABEL[value] || String(value)
      }))
    }
  },
  created() {
    const adNo = this.$route.query && this.$route.query.adNo
    const enterprisePromise = this.loadEnterprises()
    if (adNo) {
      this.form.adNo = adNo
      this.detailLoading = true
      Promise.all([enterprisePromise, this.loadDetail(adNo)])
        .then(() => this.ensureDeptTreeForEdit())
        .finally(() => {
          this.detailLoading = false
        })
    }
  },
  methods: {
    /**
     * GET /guanggao/enterprises
     * 企业作为树根节点（不可选），展开后懒加载部门
     */
    loadEnterprises() {
      return this.getHttpServices()
        .getNewServeService()
        .get('/guanggao/enterprises')
        .then(list => {
          this.groupTreeData = (list || []).map(item => ({
            title: item.enterpriseName,
            value: `e-${item.enterpriseId}`,
            key: `e-${item.enterpriseId}`,
            enterpriseId: item.enterpriseId,
            nodeType: 'enterprise',
            selectable: false,
            isLeaf: false
          }))
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '加载认证企业失败')
        })
    },
    /**
     * GET /guanggao/detail?adNo=
     */
    loadDetail(adNo) {
      return this.getHttpServices()
        .getNewServeService()
        .get('/guanggao/detail', { adNo })
        .then(detail => {
          this.fillFromDetail(detail || {})
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '加载广告详情失败')
        })
    },
    fillFromDetail(detail) {
      this.form.adNo = detail.adNo || this.form.adNo || ''
      this.form.title = detail.title || ''
      this.form.dateRange = [detail.startDate || '', detail.endDate || ''].filter(Boolean).length
        ? [detail.startDate || '', detail.endDate || '']
        : []
      this.form.frequency = detail.frequencyConfig === undefined || detail.frequencyConfig === null
        ? 0
        : detail.frequencyConfig
      this.form.deptId = detail.deptId || undefined
      this.form.enterpriseId = detail.enterpriseId || undefined

      const contentMap = {}
      const pageMap = {}
      const adTypes = []
      ;(detail.contentConfig || []).forEach(item => {
        const adType = Number(item.adType)
        if (!adType) return
        adTypes.push(adType)
        const jumpType = JUMP_TYPE_REVERSE[item.jumpType] || 'product'
        const content = createEmptyContent(adType)
        content.promotionId = item.promotionId
        content.imageUrl = item.imageUrl || ''
        content.bodyText = item.bodyText || ''
        content.jumpType = jumpType
        content.playSeconds = item.playSeconds
        content.marketingTitle = item.marketingTitle || ''
        content.buttonText = item.buttonText || ''
        if (jumpType === 'product' || jumpType === 'activity') {
          const target = item.jumpTarget
          content.targetId = jumpType === 'product' && target !== undefined && target !== ''
            ? (Number(target) || target)
            : target
          content.targetName = target ? String(target) : ''
        } else {
          content.targetUrl = item.jumpTarget || ''
        }
        contentMap[adType] = content
        pageMap[adType] = item.displayPages || []
      })
      this.form.adTypes = adTypes
      this.contentMap = contentMap
      this.pageMap = pageMap
      const first = adTypes[0]
      this.activeContentTab = first !== undefined ? String(first) : ''
      this.activeConfirmTab = first !== undefined ? String(first) : ''
    },
    ensureDeptTreeForEdit() {
      const enterpriseId = this.form.enterpriseId
      const deptId = this.form.deptId
      if (!enterpriseId || !deptId) return Promise.resolve()
      const enterpriseNode = (this.groupTreeData || []).find(
        item => String(item.enterpriseId) === String(enterpriseId)
      )
      if (!enterpriseNode) return Promise.resolve()
      return this.fetchDepartments(enterpriseId).then(list => {
        const children = this.buildDeptTree(list || [], enterpriseId)
        enterpriseNode.children = children
        enterpriseNode.isLeaf = !children.length
        this.groupTreeData = [...this.groupTreeData]
      })
    },
    fetchDepartments(enterpriseId) {
      return this.getHttpServices()
        .getNewServeService()
        .get('/guanggao/departments', { enterpriseId })
    },
    /**
     * 展开企业节点时懒加载部门
     * GET /guanggao/departments?enterpriseId=
     */
    onLoadDeptData(treeNode) {
      return new Promise(resolve => {
        const dataRef = treeNode.dataRef || treeNode
        if (dataRef.nodeType !== 'enterprise' || dataRef.children) {
          resolve()
          return
        }
        this.fetchDepartments(dataRef.enterpriseId)
          .then(list => {
            const children = this.buildDeptTree(list || [], dataRef.enterpriseId)
            dataRef.children = children
            if (!children.length) {
              dataRef.isLeaf = true
            }
            this.groupTreeData = [...this.groupTreeData]
            resolve()
          })
          .catch(err => {
            this.$message.error((err && err.msg) || '加载工行分组失败')
            resolve()
          })
      })
    },
    buildDeptTree(list, enterpriseId) {
      const nodeMap = {}
      const roots = []
      list.forEach(item => {
        nodeMap[item.deptId] = {
          title: item.deptName,
          value: item.deptId,
          key: `d-${item.deptId}`,
          deptId: item.deptId,
          enterpriseId: item.enterpriseId || enterpriseId,
          nodeType: 'dept',
          isLeaf: true,
          children: []
        }
      })
      list.forEach(item => {
        const node = nodeMap[item.deptId]
        const parent = nodeMap[item.pDeptId]
        if (item.pDeptId && parent) {
          parent.isLeaf = false
          parent.children.push(node)
        } else {
          roots.push(node)
        }
      })
      const pruneEmptyChildren = nodes => {
        nodes.forEach(node => {
          if (node.children && node.children.length) {
            pruneEmptyChildren(node.children)
          } else {
            delete node.children
            node.isLeaf = true
          }
        })
        return nodes
      }
      return pruneEmptyChildren(roots)
    },
    onDeptChange(value) {
      if (!value) {
        this.form.deptId = undefined
        this.form.enterpriseId = undefined
        return
      }
      this.form.enterpriseId = this.findEnterpriseId(this.groupTreeData, value)
    },
    findEnterpriseId(nodes, deptId) {
      for (let i = 0; i < (nodes || []).length; i++) {
        const node = nodes[i]
        if (node.nodeType === 'dept' && node.value === deptId) {
          return node.enterpriseId
        }
        const found = this.findEnterpriseId(node.children, deptId)
        if (found !== undefined) return found
      }
      return undefined
    },
    initContentForms() {
      const nextMap = { ...this.contentMap }
      ;(this.form.adTypes || []).forEach(adType => {
        if (!nextMap[adType]) {
          nextMap[adType] = createEmptyContent(adType)
        }
      })
      Object.keys(nextMap).forEach(key => {
        const adType = Number(key)
        if (!(this.form.adTypes || []).includes(adType)) {
          delete nextMap[key]
        }
      })
      this.contentMap = nextMap
      const first = (this.form.adTypes || [])[0]
      this.activeContentTab = first !== undefined ? String(first) : ''
    },
    onContentChange(adType, val) {
      this.$set(this.contentMap, adType, val)
    },
    goToStep(target) {
      if (target === this.current) return
      if (target < 0 || target >= this.steps.length) return
      // 回退可直接切
      if (target < this.current) {
        this.current = target
        return
      }
      // 前进：从第 1 步离开时先校验基本信息
      if (this.current === 0) {
        this.$refs.basicForm.validate(valid => {
          if (!valid) return
          this.initContentForms()
          if (target >= 2) this.initConfirmPages()
          this.current = target
        })
        return
      }
      if (target >= 2) this.initConfirmPages()
      this.current = target
    },
    onStepChange(current) {
      this.goToStep(current)
    },
    onStep1Next() {
      this.goToStep(1)
    },
    onStep2Back() {
      this.goToStep(0)
    },
    initConfirmPages() {
      const nextMap = { ...this.pageMap }
      ;(this.form.adTypes || []).forEach(adType => {
        if (!nextMap[adType]) {
          // 新建：开屏广告默认勾选「首页」
          nextMap[adType] = Number(adType) === 1 ? [1] : []
        }
      })
      Object.keys(nextMap).forEach(key => {
        const adType = Number(key)
        if (!(this.form.adTypes || []).includes(adType)) {
          delete nextMap[key]
        }
      })
      this.pageMap = nextMap
      const first = (this.form.adTypes || [])[0]
      this.activeConfirmTab = first !== undefined ? String(first) : ''
    },
    onPagesChange({ adType, pages }) {
      this.$set(this.pageMap, adType, pages || [])
    },
    onStep2Next() {
      this.goToStep(2)
    },
    onStep3Back() {
      this.goToStep(1)
    },
    getJumpTarget(content) {
      if (!content) return ''
      if (content.jumpType === 'product' || content.jumpType === 'activity') {
        return content.targetId === undefined || content.targetId === null
          ? ''
          : String(content.targetId)
      }
      return content.targetUrl || ''
    },
    buildContentConfig() {
      return (this.form.adTypes || []).map(adType => {
        const content = this.contentMap[adType] || {}
        const pages = this.pageMap[adType] || []
        const item = {
          adType: Number(adType),
          imageUrl: content.imageUrl || '',
          bodyText: content.bodyText || '',
          jumpType: JUMP_TYPE_MAP[content.jumpType] || 1,
          jumpTarget: this.getJumpTarget(content),
          marketingTitle: content.marketingTitle || '',
          buttonText: content.buttonText || '',
          displayPages: pages
        }
        if (content.promotionId !== undefined && content.promotionId !== null && content.promotionId !== '') {
          item.promotionId = content.promotionId
        }
        if (content.playSeconds !== undefined && content.playSeconds !== null && content.playSeconds !== '') {
          item.playSeconds = Number(content.playSeconds)
        }
        return item
      })
    },
    /**
     * POST /guanggao/save
     * 新建不传 adNo；编辑传详情回显的 adNo
     */
    buildSavePayload() {
      const dateRange = this.form.dateRange || []
      const payload = {
        title: this.form.title || '',
        startDate: dateRange[0] || '',
        endDate: dateRange[1] || '',
        frequencyConfig: this.form.frequency,
        contentConfig: this.buildContentConfig()
      }
      if (this.form.deptId) {
        payload.deptId = this.form.deptId
      }
      if (this.form.adNo) {
        payload.adNo = this.form.adNo
      }
      return payload
    },
    validateBeforePublish() {
      const adTypes = this.form.adTypes || []
      for (let i = 0; i < adTypes.length; i++) {
        const adType = adTypes[i]
        const label = AD_TYPE_TAB_LABEL[adType] || `类型${adType}`
        const content = this.contentMap[adType] || {}
        const pages = this.pageMap[adType] || []
        const hasImage = !!(content.imageUrl && String(content.imageUrl).trim())
        const hasBody = !!(content.bodyText && String(content.bodyText).trim())
        if (!hasImage && !hasBody) {
          this.$message.warning(`请完善「${label}」的图片或插屏内容`)
          this.activeConfirmTab = String(adType)
          this.activeContentTab = String(adType)
          return false
        }
        if (!this.getJumpTarget(content)) {
          this.$message.warning(`请完善「${label}」的跳转目标`)
          this.activeContentTab = String(adType)
          this.current = 1
          return false
        }
        if (!pages.length) {
          this.$message.warning(`请为「${label}」选择广告展示页面`)
          this.activeConfirmTab = String(adType)
          return false
        }
      }
      return true
    },
    onPublish() {
      if (this.publishing) return
      if (!this.validateBeforePublish()) return
      const payload = this.buildSavePayload()
      this.publishing = true
      this.getHttpServices()
        .getNewServeService()
        .post('/guanggao/save', payload)
        .then(() => {
          this.$message.success(this.isEdit ? '保存成功' : '发布成功')
          this.$router.push({ name: 'Advertisement' })
        })
        .catch(err => {
          this.$message.error((err && err.msg) || (this.isEdit ? '保存失败，请重试' : '发布失败，请重试'))
        })
        .then(() => {
          this.publishing = false
        })
    }
  }
}
</script>

<style scoped lang="less">
.advertisement-create-page {
  .steps-wrap {
    max-width: 820px;
    margin: 8px auto 40px;

    /deep/ .ant-steps-item {
      cursor: pointer;
    }
  }

  .step-panel {
    max-width: 900px;
    margin: 0 auto;
  }

  .step-panel-content {
    max-width: 980px;
  }

  .step-panel-confirm {
    max-width: 1100px;
  }

  .footer-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 0 8px;
    border-top: 1px solid #f0f0f0;
  }
}
</style>
